module.exports = __webpack_public_path__ + "static/media/dana_logo.3b12ae51.svg";